import { render, staticRenderFns } from "./detailTingBoxCtv.vue?vue&type=template&id=752763de&scoped=true"
import script from "./detailTingBoxCtv.vue?vue&type=script&lang=js"
export * from "./detailTingBoxCtv.vue?vue&type=script&lang=js"
import style0 from "./detailTingBoxCtv.vue?vue&type=style&index=0&id=752763de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752763de",
  null
  
)

export default component.exports